import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Grid,
  Paper
} from '@mui/material';

import {
  Details,
  Review
} from './components';

import {
  searchDetailsColumnSx,
  searchDetailsGridItemSx,
  searchDetailsGridSx,
  searchDetailsPaperSx,
  searchDetailsRootSx
} from './SearchDetailsStyles';

const SearchDetails = ({ className }) => {
  return (
    <Box
      className={className}
      sx={searchDetailsRootSx}>
      <Paper
        elevation={0}
        sx={searchDetailsPaperSx}>
        <Grid
          container
          columnSpacing={1}
          alignItems="stretch"
          sx={searchDetailsGridSx}>
          <Grid
            size={{ xs: 12, md: 8 }}
            sx={searchDetailsGridItemSx}>
            <Box sx={searchDetailsColumnSx}>
              <Details />
            </Box>
          </Grid>

          <Grid
            size={{ xs: 12, md: 4 }}
            sx={searchDetailsGridItemSx}>
            <Box sx={searchDetailsColumnSx}>
              <Review />
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

SearchDetails.propTypes = {
  className: PropTypes.string
};

export default SearchDetails;